import type { CartLineStockShape, StockLevelLike } from "./cart-stock.types";

export type { CartLineStockShape, StockLevelLike } from "./cart-stock.types";

export function getSaleableStockFromLevels(
    stockLevels: StockLevelLike[] | null | undefined
): number {
    if (!stockLevels?.length) {
        return 0;
    }
    return stockLevels.reduce((sum, sl) => {
        const onHand = sl.stockOnHand ?? 0;
        const allocated = sl.stockAllocated ?? 0;
        return sum + Math.max(0, onHand - allocated);
    }, 0);
}

export function hasLineStockIssue(line: CartLineStockShape): boolean {
    const pv = line.productVariant;
    if (pv?.isDeleted) {
        return true;
    }
    const saleable = getSaleableStockFromLevels(pv?.stockLevels ?? undefined);
    return line.quantity > saleable;
}

export function orderHasStockIssues(
    order: { lines?: CartLineStockShape[] | null } | null | undefined
): boolean {
    if (!order?.lines?.length) {
        return false;
    }
    return order.lines.some((line) => hasLineStockIssue(line));
}
